var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('CrmFunnelMemberListUi',{attrs:{"members":_vm.rows,"saving":_vm.saving,"canManage":_vm.canManage},on:{"add":_vm.addMembers,"remove":_vm.removeMember}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }